import { useQuery } from '@tanstack/react-query';
import { meetingApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry One meeting with its topics, issues and comments — the edit form's source of truth. */
export function useMeeting(
  jobId: number | null | undefined,
  meetingId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.meetings.detail(jobId ?? -1, meetingId ?? ''),
    queryFn: ({ signal }) =>
      meetingApiClient.getMeetingById(
        jobId!,
        meetingId!,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!meetingId,
    staleTime: 0,
    meta: { errorContext: 'meeting detail' },
  });
}
